/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddOrganizationRiskThreatsToOrganizationRisk } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { HighestRisksPerCategory } from '../model';
// @ts-ignore
import type { OrganizationRisk } from '../model';
// @ts-ignore
import type { OrganizationRiskCategory } from '../model';
// @ts-ignore
import type { OrganizationRiskCategoryCreate } from '../model';
// @ts-ignore
import type { OrganizationRiskCategoryPaginated } from '../model';
// @ts-ignore
import type { OrganizationRiskCategorySorting } from '../model';
// @ts-ignore
import type { OrganizationRiskCategoryUpdate } from '../model';
// @ts-ignore
import type { OrganizationRiskCreate } from '../model';
// @ts-ignore
import type { OrganizationRiskExpandedPaginated } from '../model';
// @ts-ignore
import type { OrganizationRiskPaginated } from '../model';
// @ts-ignore
import type { OrganizationRiskSorting } from '../model';
// @ts-ignore
import type { OrganizationRiskThreat } from '../model';
// @ts-ignore
import type { OrganizationRiskThreatCreate } from '../model';
// @ts-ignore
import type { OrganizationRiskThreatPaginated } from '../model';
// @ts-ignore
import type { OrganizationRiskThreatSorting } from '../model';
// @ts-ignore
import type { OrganizationRiskThreatUpdate } from '../model';
// @ts-ignore
import type { OrganizationRiskUpdate } from '../model';
// @ts-ignore
import type { OrganizationRisksOverview } from '../model';
// @ts-ignore
import type { ProjectByRiskValue } from '../model';
// @ts-ignore
import type { RiskPortfolioGroupBy } from '../model';
// @ts-ignore
import type { RiskPortfolioOverview } from '../model';
// @ts-ignore
import type { RiskPortfolioProject } from '../model';
// @ts-ignore
import type { RiskPortfolioRiskCategory } from '../model';
// @ts-ignore
import type { RiskStatusByCategory } from '../model';
/**
 * OrganizationRisksApi - axios parameter creator
 */
export const OrganizationRisksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add threats to an organization risk.
         * @summary Add Organization Risk Threats To Organization Risk
         * @param {string} organizationRiskId 
         * @param {AddOrganizationRiskThreatsToOrganizationRisk} addOrganizationRiskThreatsToOrganizationRisk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationRiskThreatsToOrganizationRisk: async (organizationRiskId: string, addOrganizationRiskThreatsToOrganizationRisk: AddOrganizationRiskThreatsToOrganizationRisk, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskId' is not null or undefined
            assertParamExists('addOrganizationRiskThreatsToOrganizationRisk', 'organizationRiskId', organizationRiskId)
            // verify required parameter 'addOrganizationRiskThreatsToOrganizationRisk' is not null or undefined
            assertParamExists('addOrganizationRiskThreatsToOrganizationRisk', 'addOrganizationRiskThreatsToOrganizationRisk', addOrganizationRiskThreatsToOrganizationRisk)
            const localVarPath = `/organization-risks/{organization_risk_id}/threats`
                .replace('{organization_risk_id}', encodeURIComponent(String(organizationRiskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrganizationRiskThreatsToOrganizationRisk, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an organization risk.
         * @summary Archive Organization Risk
         * @param {string} organizationRiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveOrganizationRisk: async (organizationRiskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskId' is not null or undefined
            assertParamExists('archiveOrganizationRisk', 'organizationRiskId', organizationRiskId)
            const localVarPath = `/organization-risks/{organization_risk_id}`
                .replace('{organization_risk_id}', encodeURIComponent(String(organizationRiskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete an organization risk category.
         * @summary Archive Organization Risk Category
         * @param {string} organizationRiskCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveOrganizationRiskCategory: async (organizationRiskCategoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskCategoryId' is not null or undefined
            assertParamExists('archiveOrganizationRiskCategory', 'organizationRiskCategoryId', organizationRiskCategoryId)
            const localVarPath = `/organization-risk-categories/{organization_risk_category_id}`
                .replace('{organization_risk_category_id}', encodeURIComponent(String(organizationRiskCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete an organization risk threat.
         * @summary Archive Organization Risk Threat
         * @param {string} organizationRiskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveOrganizationRiskThreat: async (organizationRiskThreatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskThreatId' is not null or undefined
            assertParamExists('archiveOrganizationRiskThreat', 'organizationRiskThreatId', organizationRiskThreatId)
            const localVarPath = `/organization-risk-threats/{organization_risk_threat_id}`
                .replace('{organization_risk_threat_id}', encodeURIComponent(String(organizationRiskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new organization risk.
         * @summary Create Organization Risk
         * @param {OrganizationRiskCreate} organizationRiskCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationRisk: async (organizationRiskCreate: OrganizationRiskCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskCreate' is not null or undefined
            assertParamExists('createOrganizationRisk', 'organizationRiskCreate', organizationRiskCreate)
            const localVarPath = `/organization-risks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationRiskCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an organization risk category for the organization.
         * @summary Create Organization Risk Category
         * @param {OrganizationRiskCategoryCreate} organizationRiskCategoryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationRiskCategory: async (organizationRiskCategoryCreate: OrganizationRiskCategoryCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskCategoryCreate' is not null or undefined
            assertParamExists('createOrganizationRiskCategory', 'organizationRiskCategoryCreate', organizationRiskCategoryCreate)
            const localVarPath = `/organization-risk-categories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationRiskCategoryCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an organization risk threat for the organization.
         * @summary Create Organization Risk Threat
         * @param {OrganizationRiskThreatCreate} organizationRiskThreatCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationRiskThreat: async (organizationRiskThreatCreate: OrganizationRiskThreatCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskThreatCreate' is not null or undefined
            assertParamExists('createOrganizationRiskThreat', 'organizationRiskThreatCreate', organizationRiskThreatCreate)
            const localVarPath = `/organization-risk-threats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationRiskThreatCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an organization risk threat from an organization risk.
         * @summary Delete Organization Risk Threat
         * @param {string} organizationRiskId 
         * @param {string} organizationRiskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationRiskThreat: async (organizationRiskId: string, organizationRiskThreatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskId' is not null or undefined
            assertParamExists('deleteOrganizationRiskThreat', 'organizationRiskId', organizationRiskId)
            // verify required parameter 'organizationRiskThreatId' is not null or undefined
            assertParamExists('deleteOrganizationRiskThreat', 'organizationRiskThreatId', organizationRiskThreatId)
            const localVarPath = `/organization-risks/{organization_risk_id}/threats/{organization_risk_threat_id}`
                .replace('{organization_risk_id}', encodeURIComponent(String(organizationRiskId)))
                .replace('{organization_risk_threat_id}', encodeURIComponent(String(organizationRiskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a organization risk by its ID.
         * @summary Get Organization Risk
         * @param {string} organizationRiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRisk: async (organizationRiskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskId' is not null or undefined
            assertParamExists('getOrganizationRisk', 'organizationRiskId', organizationRiskId)
            const localVarPath = `/organization-risks/{organization_risk_id}`
                .replace('{organization_risk_id}', encodeURIComponent(String(organizationRiskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get organization risk categories of the organization.
         * @summary Get Organization Risk Categories
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationRiskCategorySorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskCategories: async (page?: number, size?: number, sortBy?: OrganizationRiskCategorySorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, includeArchived?: boolean, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-risk-categories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a organization risk category by its ID.
         * @summary Get Organization Risk Category
         * @param {string} organizationRiskCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskCategory: async (organizationRiskCategoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskCategoryId' is not null or undefined
            assertParamExists('getOrganizationRiskCategory', 'organizationRiskCategoryId', organizationRiskCategoryId)
            const localVarPath = `/organization-risk-categories/{organization_risk_category_id}`
                .replace('{organization_risk_category_id}', encodeURIComponent(String(organizationRiskCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the risk portfolio of the organization: every visible Approved or Pending AI System with its Risk Category roll-ups.
         * @summary Get Organization Risk Portfolio
         * @param {RiskPortfolioGroupBy} [groupBy] AI System field to group by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskPortfolio: async (groupBy?: RiskPortfolioGroupBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-risks/portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupBy !== undefined) {
                localVarQueryParameter['group_by'] = groupBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return one AI System of the portfolio with its Risk Categories, Risks and Threat Vectors.
         * @summary Get Organization Risk Portfolio Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskPortfolioProject: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getOrganizationRiskPortfolioProject', 'projectId', projectId)
            const localVarPath = `/organization-risks/portfolio/projects/{project_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return one Risk Category of the portfolio with its Risks and their top AI Systems.
         * @summary Get Organization Risk Portfolio Risk Category
         * @param {string} riskCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskPortfolioRiskCategory: async (riskCategoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskCategoryId' is not null or undefined
            assertParamExists('getOrganizationRiskPortfolioRiskCategory', 'riskCategoryId', riskCategoryId)
            const localVarPath = `/organization-risks/portfolio/risk-categories/{risk_category_id}`
                .replace('{risk_category_id}', encodeURIComponent(String(riskCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return risk status by category for an organization.
         * @summary Get Organization Risk Status By Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskStatusByCategory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-risks/metrics/risk-status-by-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an organization risk threat.
         * @summary Get Organization Risk Threat
         * @param {string} organizationRiskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskThreat: async (organizationRiskThreatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskThreatId' is not null or undefined
            assertParamExists('getOrganizationRiskThreat', 'organizationRiskThreatId', organizationRiskThreatId)
            const localVarPath = `/organization-risk-threats/{organization_risk_threat_id}`
                .replace('{organization_risk_threat_id}', encodeURIComponent(String(organizationRiskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated organization risk threats for the active organization.
         * @summary Get Organization Risk Threats
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationRiskThreatSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskThreats: async (page?: number, size?: number, sortBy?: OrganizationRiskThreatSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, includeArchived?: boolean, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-risk-threats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all organization risks.
         * @summary Get Organization Risks
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationRiskSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationRiskCategoryId] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string> | null} [organizationRiskThreatIds] Filter by organization risk threat IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRisks: async (page?: number, size?: number, sortBy?: OrganizationRiskSorting | null, descending?: boolean | null, organizationRiskCategoryId?: string | null, nameOrUniqueCode?: string | null, includeArchived?: boolean, exactMatch?: boolean, organizationRiskThreatIds?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-risks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (organizationRiskCategoryId !== undefined) {
                localVarQueryParameter['organization_risk_category_id'] = organizationRiskCategoryId;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            if (organizationRiskThreatIds) {
                localVarQueryParameter['organization_risk_threat_ids'] = organizationRiskThreatIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all organization risks.
         * @summary Get Organization Risks Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationRiskSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationRiskCategoryId] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string> | null} [organizationRiskThreatIds] Filter by organization risk threat IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRisksExpanded: async (page?: number, size?: number, sortBy?: OrganizationRiskSorting | null, descending?: boolean | null, organizationRiskCategoryId?: string | null, nameOrUniqueCode?: string | null, includeArchived?: boolean, exactMatch?: boolean, organizationRiskThreatIds?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-risks/expanded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (organizationRiskCategoryId !== undefined) {
                localVarQueryParameter['organization_risk_category_id'] = organizationRiskCategoryId;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            if (organizationRiskThreatIds) {
                localVarQueryParameter['organization_risk_threat_ids'] = organizationRiskThreatIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return risk overview by organization.
         * @summary Get Organization Risks Overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRisksOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-risks/metrics/risks-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return Top risks by category.
         * @summary Get Organization Top Risk Per Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTopRiskPerCategory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-risks/metrics/top-risks-per-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query organization risk threats with pagination.
         * @summary Get Risk Threats From Organization Risks
         * @param {string} organizationRiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatsFromOrganizationRisks: async (organizationRiskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskId' is not null or undefined
            assertParamExists('getRiskThreatsFromOrganizationRisks', 'organizationRiskId', organizationRiskId)
            const localVarPath = `/organization-risks/{organization_risk_id}/threats`
                .replace('{organization_risk_id}', encodeURIComponent(String(organizationRiskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return top projects by risk value.
         * @summary Get Top Projects By Risk Value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopProjectsByRiskValue: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization-risks/metrics/top-projects-by-risk-value`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an organization risk by its ID.
         * @summary Update Organization Risk
         * @param {string} organizationRiskId 
         * @param {OrganizationRiskUpdate} organizationRiskUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationRisk: async (organizationRiskId: string, organizationRiskUpdate: OrganizationRiskUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskId' is not null or undefined
            assertParamExists('updateOrganizationRisk', 'organizationRiskId', organizationRiskId)
            // verify required parameter 'organizationRiskUpdate' is not null or undefined
            assertParamExists('updateOrganizationRisk', 'organizationRiskUpdate', organizationRiskUpdate)
            const localVarPath = `/organization-risks/{organization_risk_id}`
                .replace('{organization_risk_id}', encodeURIComponent(String(organizationRiskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationRiskUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a organization risk category by its ID.
         * @summary Update Organization Risk Category
         * @param {string} organizationRiskCategoryId 
         * @param {OrganizationRiskCategoryUpdate} organizationRiskCategoryUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationRiskCategory: async (organizationRiskCategoryId: string, organizationRiskCategoryUpdate: OrganizationRiskCategoryUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskCategoryId' is not null or undefined
            assertParamExists('updateOrganizationRiskCategory', 'organizationRiskCategoryId', organizationRiskCategoryId)
            // verify required parameter 'organizationRiskCategoryUpdate' is not null or undefined
            assertParamExists('updateOrganizationRiskCategory', 'organizationRiskCategoryUpdate', organizationRiskCategoryUpdate)
            const localVarPath = `/organization-risk-categories/{organization_risk_category_id}`
                .replace('{organization_risk_category_id}', encodeURIComponent(String(organizationRiskCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationRiskCategoryUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an organization risk threat by its ID.
         * @summary Update Organization Risk Threat
         * @param {string} organizationRiskThreatId 
         * @param {OrganizationRiskThreatUpdate} organizationRiskThreatUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationRiskThreat: async (organizationRiskThreatId: string, organizationRiskThreatUpdate: OrganizationRiskThreatUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRiskThreatId' is not null or undefined
            assertParamExists('updateOrganizationRiskThreat', 'organizationRiskThreatId', organizationRiskThreatId)
            // verify required parameter 'organizationRiskThreatUpdate' is not null or undefined
            assertParamExists('updateOrganizationRiskThreat', 'organizationRiskThreatUpdate', organizationRiskThreatUpdate)
            const localVarPath = `/organization-risk-threats/{organization_risk_threat_id}`
                .replace('{organization_risk_threat_id}', encodeURIComponent(String(organizationRiskThreatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationRiskThreatUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationRisksApi - functional programming interface
 */
export const OrganizationRisksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationRisksApiAxiosParamCreator(configuration)
    return {
        /**
         * Add threats to an organization risk.
         * @summary Add Organization Risk Threats To Organization Risk
         * @param {string} organizationRiskId 
         * @param {AddOrganizationRiskThreatsToOrganizationRisk} addOrganizationRiskThreatsToOrganizationRisk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganizationRiskThreatsToOrganizationRisk(organizationRiskId: string, addOrganizationRiskThreatsToOrganizationRisk: AddOrganizationRiskThreatsToOrganizationRisk, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationRiskThreat>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganizationRiskThreatsToOrganizationRisk(organizationRiskId, addOrganizationRiskThreatsToOrganizationRisk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.addOrganizationRiskThreatsToOrganizationRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an organization risk.
         * @summary Archive Organization Risk
         * @param {string} organizationRiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveOrganizationRisk(organizationRiskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveOrganizationRisk(organizationRiskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.archiveOrganizationRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft delete an organization risk category.
         * @summary Archive Organization Risk Category
         * @param {string} organizationRiskCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveOrganizationRiskCategory(organizationRiskCategoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveOrganizationRiskCategory(organizationRiskCategoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.archiveOrganizationRiskCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft delete an organization risk threat.
         * @summary Archive Organization Risk Threat
         * @param {string} organizationRiskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveOrganizationRiskThreat(organizationRiskThreatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveOrganizationRiskThreat(organizationRiskThreatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.archiveOrganizationRiskThreat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new organization risk.
         * @summary Create Organization Risk
         * @param {OrganizationRiskCreate} organizationRiskCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationRisk(organizationRiskCreate: OrganizationRiskCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRisk>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationRisk(organizationRiskCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.createOrganizationRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an organization risk category for the organization.
         * @summary Create Organization Risk Category
         * @param {OrganizationRiskCategoryCreate} organizationRiskCategoryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationRiskCategory(organizationRiskCategoryCreate: OrganizationRiskCategoryCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationRiskCategory(organizationRiskCategoryCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.createOrganizationRiskCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an organization risk threat for the organization.
         * @summary Create Organization Risk Threat
         * @param {OrganizationRiskThreatCreate} organizationRiskThreatCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationRiskThreat(organizationRiskThreatCreate: OrganizationRiskThreatCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskThreat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationRiskThreat(organizationRiskThreatCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.createOrganizationRiskThreat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an organization risk threat from an organization risk.
         * @summary Delete Organization Risk Threat
         * @param {string} organizationRiskId 
         * @param {string} organizationRiskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationRiskThreat(organizationRiskId: string, organizationRiskThreatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationRiskThreat(organizationRiskId, organizationRiskThreatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.deleteOrganizationRiskThreat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a organization risk by its ID.
         * @summary Get Organization Risk
         * @param {string} organizationRiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRisk(organizationRiskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRisk>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRisk(organizationRiskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get organization risk categories of the organization.
         * @summary Get Organization Risk Categories
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationRiskCategorySorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRiskCategories(page?: number, size?: number, sortBy?: OrganizationRiskCategorySorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, includeArchived?: boolean, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskCategoryPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRiskCategories(page, size, sortBy, descending, nameOrUniqueCode, includeArchived, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRiskCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a organization risk category by its ID.
         * @summary Get Organization Risk Category
         * @param {string} organizationRiskCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRiskCategory(organizationRiskCategoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRiskCategory(organizationRiskCategoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRiskCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the risk portfolio of the organization: every visible Approved or Pending AI System with its Risk Category roll-ups.
         * @summary Get Organization Risk Portfolio
         * @param {RiskPortfolioGroupBy} [groupBy] AI System field to group by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRiskPortfolio(groupBy?: RiskPortfolioGroupBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskPortfolioOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRiskPortfolio(groupBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRiskPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return one AI System of the portfolio with its Risk Categories, Risks and Threat Vectors.
         * @summary Get Organization Risk Portfolio Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRiskPortfolioProject(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskPortfolioProject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRiskPortfolioProject(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRiskPortfolioProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return one Risk Category of the portfolio with its Risks and their top AI Systems.
         * @summary Get Organization Risk Portfolio Risk Category
         * @param {string} riskCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRiskPortfolioRiskCategory(riskCategoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskPortfolioRiskCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRiskPortfolioRiskCategory(riskCategoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRiskPortfolioRiskCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return risk status by category for an organization.
         * @summary Get Organization Risk Status By Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRiskStatusByCategory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskStatusByCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRiskStatusByCategory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRiskStatusByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an organization risk threat.
         * @summary Get Organization Risk Threat
         * @param {string} organizationRiskThreatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRiskThreat(organizationRiskThreatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskThreat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRiskThreat(organizationRiskThreatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRiskThreat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated organization risk threats for the active organization.
         * @summary Get Organization Risk Threats
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationRiskThreatSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRiskThreats(page?: number, size?: number, sortBy?: OrganizationRiskThreatSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, includeArchived?: boolean, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskThreatPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRiskThreats(page, size, sortBy, descending, nameOrUniqueCode, includeArchived, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRiskThreats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all organization risks.
         * @summary Get Organization Risks
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationRiskSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationRiskCategoryId] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string> | null} [organizationRiskThreatIds] Filter by organization risk threat IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRisks(page?: number, size?: number, sortBy?: OrganizationRiskSorting | null, descending?: boolean | null, organizationRiskCategoryId?: string | null, nameOrUniqueCode?: string | null, includeArchived?: boolean, exactMatch?: boolean, organizationRiskThreatIds?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRisks(page, size, sortBy, descending, organizationRiskCategoryId, nameOrUniqueCode, includeArchived, exactMatch, organizationRiskThreatIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRisks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all organization risks.
         * @summary Get Organization Risks Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {OrganizationRiskSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [organizationRiskCategoryId] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [exactMatch] 
         * @param {Array<string> | null} [organizationRiskThreatIds] Filter by organization risk threat IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRisksExpanded(page?: number, size?: number, sortBy?: OrganizationRiskSorting | null, descending?: boolean | null, organizationRiskCategoryId?: string | null, nameOrUniqueCode?: string | null, includeArchived?: boolean, exactMatch?: boolean, organizationRiskThreatIds?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRisksExpanded(page, size, sortBy, descending, organizationRiskCategoryId, nameOrUniqueCode, includeArchived, exactMatch, organizationRiskThreatIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRisksExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return risk overview by organization.
         * @summary Get Organization Risks Overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationRisksOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRisksOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationRisksOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationRisksOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return Top risks by category.
         * @summary Get Organization Top Risk Per Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationTopRiskPerCategory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HighestRisksPerCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationTopRiskPerCategory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getOrganizationTopRiskPerCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query organization risk threats with pagination.
         * @summary Get Risk Threats From Organization Risks
         * @param {string} organizationRiskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskThreatsFromOrganizationRisks(organizationRiskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationRiskThreat>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskThreatsFromOrganizationRisks(organizationRiskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getRiskThreatsFromOrganizationRisks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return top projects by risk value.
         * @summary Get Top Projects By Risk Value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopProjectsByRiskValue(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectByRiskValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopProjectsByRiskValue(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.getTopProjectsByRiskValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an organization risk by its ID.
         * @summary Update Organization Risk
         * @param {string} organizationRiskId 
         * @param {OrganizationRiskUpdate} organizationRiskUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationRisk(organizationRiskId: string, organizationRiskUpdate: OrganizationRiskUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRisk>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationRisk(organizationRiskId, organizationRiskUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.updateOrganizationRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a organization risk category by its ID.
         * @summary Update Organization Risk Category
         * @param {string} organizationRiskCategoryId 
         * @param {OrganizationRiskCategoryUpdate} organizationRiskCategoryUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationRiskCategory(organizationRiskCategoryId: string, organizationRiskCategoryUpdate: OrganizationRiskCategoryUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationRiskCategory(organizationRiskCategoryId, organizationRiskCategoryUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.updateOrganizationRiskCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an organization risk threat by its ID.
         * @summary Update Organization Risk Threat
         * @param {string} organizationRiskThreatId 
         * @param {OrganizationRiskThreatUpdate} organizationRiskThreatUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationRiskThreat(organizationRiskThreatId: string, organizationRiskThreatUpdate: OrganizationRiskThreatUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRiskThreat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationRiskThreat(organizationRiskThreatId, organizationRiskThreatUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationRisksApi.updateOrganizationRiskThreat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationRisksApi - factory interface
 */
export const OrganizationRisksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationRisksApiFp(configuration)
    return {
        /**
         * Add threats to an organization risk.
         * @summary Add Organization Risk Threats To Organization Risk
         * @param {OrganizationRisksApiAddOrganizationRiskThreatsToOrganizationRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationRiskThreatsToOrganizationRisk(requestParameters: OrganizationRisksApiAddOrganizationRiskThreatsToOrganizationRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganizationRiskThreat>> {
            return localVarFp.addOrganizationRiskThreatsToOrganizationRisk(requestParameters.organizationRiskId, requestParameters.addOrganizationRiskThreatsToOrganizationRisk, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an organization risk.
         * @summary Archive Organization Risk
         * @param {OrganizationRisksApiArchiveOrganizationRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveOrganizationRisk(requestParameters: OrganizationRisksApiArchiveOrganizationRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveOrganizationRisk(requestParameters.organizationRiskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete an organization risk category.
         * @summary Archive Organization Risk Category
         * @param {OrganizationRisksApiArchiveOrganizationRiskCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveOrganizationRiskCategory(requestParameters: OrganizationRisksApiArchiveOrganizationRiskCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveOrganizationRiskCategory(requestParameters.organizationRiskCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete an organization risk threat.
         * @summary Archive Organization Risk Threat
         * @param {OrganizationRisksApiArchiveOrganizationRiskThreatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveOrganizationRiskThreat(requestParameters: OrganizationRisksApiArchiveOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveOrganizationRiskThreat(requestParameters.organizationRiskThreatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new organization risk.
         * @summary Create Organization Risk
         * @param {OrganizationRisksApiCreateOrganizationRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationRisk(requestParameters: OrganizationRisksApiCreateOrganizationRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRisk> {
            return localVarFp.createOrganizationRisk(requestParameters.organizationRiskCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an organization risk category for the organization.
         * @summary Create Organization Risk Category
         * @param {OrganizationRisksApiCreateOrganizationRiskCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationRiskCategory(requestParameters: OrganizationRisksApiCreateOrganizationRiskCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskCategory> {
            return localVarFp.createOrganizationRiskCategory(requestParameters.organizationRiskCategoryCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an organization risk threat for the organization.
         * @summary Create Organization Risk Threat
         * @param {OrganizationRisksApiCreateOrganizationRiskThreatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationRiskThreat(requestParameters: OrganizationRisksApiCreateOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskThreat> {
            return localVarFp.createOrganizationRiskThreat(requestParameters.organizationRiskThreatCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an organization risk threat from an organization risk.
         * @summary Delete Organization Risk Threat
         * @param {OrganizationRisksApiDeleteOrganizationRiskThreatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationRiskThreat(requestParameters: OrganizationRisksApiDeleteOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrganizationRiskThreat(requestParameters.organizationRiskId, requestParameters.organizationRiskThreatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a organization risk by its ID.
         * @summary Get Organization Risk
         * @param {OrganizationRisksApiGetOrganizationRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRisk(requestParameters: OrganizationRisksApiGetOrganizationRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRisk> {
            return localVarFp.getOrganizationRisk(requestParameters.organizationRiskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get organization risk categories of the organization.
         * @summary Get Organization Risk Categories
         * @param {OrganizationRisksApiGetOrganizationRiskCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskCategories(requestParameters: OrganizationRisksApiGetOrganizationRiskCategoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskCategoryPaginated> {
            return localVarFp.getOrganizationRiskCategories(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.includeArchived, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a organization risk category by its ID.
         * @summary Get Organization Risk Category
         * @param {OrganizationRisksApiGetOrganizationRiskCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskCategory(requestParameters: OrganizationRisksApiGetOrganizationRiskCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskCategory> {
            return localVarFp.getOrganizationRiskCategory(requestParameters.organizationRiskCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the risk portfolio of the organization: every visible Approved or Pending AI System with its Risk Category roll-ups.
         * @summary Get Organization Risk Portfolio
         * @param {OrganizationRisksApiGetOrganizationRiskPortfolioRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskPortfolio(requestParameters: OrganizationRisksApiGetOrganizationRiskPortfolioRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RiskPortfolioOverview> {
            return localVarFp.getOrganizationRiskPortfolio(requestParameters.groupBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Return one AI System of the portfolio with its Risk Categories, Risks and Threat Vectors.
         * @summary Get Organization Risk Portfolio Project
         * @param {OrganizationRisksApiGetOrganizationRiskPortfolioProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskPortfolioProject(requestParameters: OrganizationRisksApiGetOrganizationRiskPortfolioProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskPortfolioProject> {
            return localVarFp.getOrganizationRiskPortfolioProject(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return one Risk Category of the portfolio with its Risks and their top AI Systems.
         * @summary Get Organization Risk Portfolio Risk Category
         * @param {OrganizationRisksApiGetOrganizationRiskPortfolioRiskCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskPortfolioRiskCategory(requestParameters: OrganizationRisksApiGetOrganizationRiskPortfolioRiskCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskPortfolioRiskCategory> {
            return localVarFp.getOrganizationRiskPortfolioRiskCategory(requestParameters.riskCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return risk status by category for an organization.
         * @summary Get Organization Risk Status By Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskStatusByCategory(options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskStatusByCategory>> {
            return localVarFp.getOrganizationRiskStatusByCategory(options).then((request) => request(axios, basePath));
        },
        /**
         * Get an organization risk threat.
         * @summary Get Organization Risk Threat
         * @param {OrganizationRisksApiGetOrganizationRiskThreatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskThreat(requestParameters: OrganizationRisksApiGetOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskThreat> {
            return localVarFp.getOrganizationRiskThreat(requestParameters.organizationRiskThreatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated organization risk threats for the active organization.
         * @summary Get Organization Risk Threats
         * @param {OrganizationRisksApiGetOrganizationRiskThreatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRiskThreats(requestParameters: OrganizationRisksApiGetOrganizationRiskThreatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskThreatPaginated> {
            return localVarFp.getOrganizationRiskThreats(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.includeArchived, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all organization risks.
         * @summary Get Organization Risks
         * @param {OrganizationRisksApiGetOrganizationRisksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRisks(requestParameters: OrganizationRisksApiGetOrganizationRisksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskPaginated> {
            return localVarFp.getOrganizationRisks(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationRiskCategoryId, requestParameters.nameOrUniqueCode, requestParameters.includeArchived, requestParameters.exactMatch, requestParameters.organizationRiskThreatIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all organization risks.
         * @summary Get Organization Risks Expanded
         * @param {OrganizationRisksApiGetOrganizationRisksExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRisksExpanded(requestParameters: OrganizationRisksApiGetOrganizationRisksExpandedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskExpandedPaginated> {
            return localVarFp.getOrganizationRisksExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationRiskCategoryId, requestParameters.nameOrUniqueCode, requestParameters.includeArchived, requestParameters.exactMatch, requestParameters.organizationRiskThreatIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Return risk overview by organization.
         * @summary Get Organization Risks Overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationRisksOverview(options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRisksOverview> {
            return localVarFp.getOrganizationRisksOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * Return Top risks by category.
         * @summary Get Organization Top Risk Per Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTopRiskPerCategory(options?: RawAxiosRequestConfig): AxiosPromise<Array<HighestRisksPerCategory>> {
            return localVarFp.getOrganizationTopRiskPerCategory(options).then((request) => request(axios, basePath));
        },
        /**
         * Query organization risk threats with pagination.
         * @summary Get Risk Threats From Organization Risks
         * @param {OrganizationRisksApiGetRiskThreatsFromOrganizationRisksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskThreatsFromOrganizationRisks(requestParameters: OrganizationRisksApiGetRiskThreatsFromOrganizationRisksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganizationRiskThreat>> {
            return localVarFp.getRiskThreatsFromOrganizationRisks(requestParameters.organizationRiskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return top projects by risk value.
         * @summary Get Top Projects By Risk Value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopProjectsByRiskValue(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProjectByRiskValue>> {
            return localVarFp.getTopProjectsByRiskValue(options).then((request) => request(axios, basePath));
        },
        /**
         * Update an organization risk by its ID.
         * @summary Update Organization Risk
         * @param {OrganizationRisksApiUpdateOrganizationRiskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationRisk(requestParameters: OrganizationRisksApiUpdateOrganizationRiskRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRisk> {
            return localVarFp.updateOrganizationRisk(requestParameters.organizationRiskId, requestParameters.organizationRiskUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a organization risk category by its ID.
         * @summary Update Organization Risk Category
         * @param {OrganizationRisksApiUpdateOrganizationRiskCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationRiskCategory(requestParameters: OrganizationRisksApiUpdateOrganizationRiskCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskCategory> {
            return localVarFp.updateOrganizationRiskCategory(requestParameters.organizationRiskCategoryId, requestParameters.organizationRiskCategoryUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an organization risk threat by its ID.
         * @summary Update Organization Risk Threat
         * @param {OrganizationRisksApiUpdateOrganizationRiskThreatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationRiskThreat(requestParameters: OrganizationRisksApiUpdateOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationRiskThreat> {
            return localVarFp.updateOrganizationRiskThreat(requestParameters.organizationRiskThreatId, requestParameters.organizationRiskThreatUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addOrganizationRiskThreatsToOrganizationRisk operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiAddOrganizationRiskThreatsToOrganizationRiskRequest {
    readonly organizationRiskId: string

    readonly addOrganizationRiskThreatsToOrganizationRisk: AddOrganizationRiskThreatsToOrganizationRisk
}

/**
 * Request parameters for archiveOrganizationRisk operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiArchiveOrganizationRiskRequest {
    readonly organizationRiskId: string
}

/**
 * Request parameters for archiveOrganizationRiskCategory operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiArchiveOrganizationRiskCategoryRequest {
    readonly organizationRiskCategoryId: string
}

/**
 * Request parameters for archiveOrganizationRiskThreat operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiArchiveOrganizationRiskThreatRequest {
    readonly organizationRiskThreatId: string
}

/**
 * Request parameters for createOrganizationRisk operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiCreateOrganizationRiskRequest {
    readonly organizationRiskCreate: OrganizationRiskCreate
}

/**
 * Request parameters for createOrganizationRiskCategory operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiCreateOrganizationRiskCategoryRequest {
    readonly organizationRiskCategoryCreate: OrganizationRiskCategoryCreate
}

/**
 * Request parameters for createOrganizationRiskThreat operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiCreateOrganizationRiskThreatRequest {
    readonly organizationRiskThreatCreate: OrganizationRiskThreatCreate
}

/**
 * Request parameters for deleteOrganizationRiskThreat operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiDeleteOrganizationRiskThreatRequest {
    readonly organizationRiskId: string

    readonly organizationRiskThreatId: string
}

/**
 * Request parameters for getOrganizationRisk operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRiskRequest {
    readonly organizationRiskId: string
}

/**
 * Request parameters for getOrganizationRiskCategories operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRiskCategoriesRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: OrganizationRiskCategorySorting | null

    readonly descending?: boolean | null

    readonly nameOrUniqueCode?: string | null

    readonly includeArchived?: boolean

    readonly exactMatch?: boolean
}

/**
 * Request parameters for getOrganizationRiskCategory operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRiskCategoryRequest {
    readonly organizationRiskCategoryId: string
}

/**
 * Request parameters for getOrganizationRiskPortfolio operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRiskPortfolioRequest {
    /**
     * AI System field to group by.
     */
    readonly groupBy?: RiskPortfolioGroupBy
}

/**
 * Request parameters for getOrganizationRiskPortfolioProject operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRiskPortfolioProjectRequest {
    readonly projectId: string
}

/**
 * Request parameters for getOrganizationRiskPortfolioRiskCategory operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRiskPortfolioRiskCategoryRequest {
    readonly riskCategoryId: string
}

/**
 * Request parameters for getOrganizationRiskThreat operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRiskThreatRequest {
    readonly organizationRiskThreatId: string
}

/**
 * Request parameters for getOrganizationRiskThreats operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRiskThreatsRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: OrganizationRiskThreatSorting | null

    readonly descending?: boolean | null

    readonly nameOrUniqueCode?: string | null

    readonly includeArchived?: boolean

    readonly exactMatch?: boolean
}

/**
 * Request parameters for getOrganizationRisks operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRisksRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: OrganizationRiskSorting | null

    readonly descending?: boolean | null

    readonly organizationRiskCategoryId?: string | null

    readonly nameOrUniqueCode?: string | null

    readonly includeArchived?: boolean

    readonly exactMatch?: boolean

    /**
     * Filter by organization risk threat IDs.
     */
    readonly organizationRiskThreatIds?: Array<string> | null
}

/**
 * Request parameters for getOrganizationRisksExpanded operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetOrganizationRisksExpandedRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: OrganizationRiskSorting | null

    readonly descending?: boolean | null

    readonly organizationRiskCategoryId?: string | null

    readonly nameOrUniqueCode?: string | null

    readonly includeArchived?: boolean

    readonly exactMatch?: boolean

    /**
     * Filter by organization risk threat IDs.
     */
    readonly organizationRiskThreatIds?: Array<string> | null
}

/**
 * Request parameters for getRiskThreatsFromOrganizationRisks operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiGetRiskThreatsFromOrganizationRisksRequest {
    readonly organizationRiskId: string
}

/**
 * Request parameters for updateOrganizationRisk operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiUpdateOrganizationRiskRequest {
    readonly organizationRiskId: string

    readonly organizationRiskUpdate: OrganizationRiskUpdate
}

/**
 * Request parameters for updateOrganizationRiskCategory operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiUpdateOrganizationRiskCategoryRequest {
    readonly organizationRiskCategoryId: string

    readonly organizationRiskCategoryUpdate: OrganizationRiskCategoryUpdate
}

/**
 * Request parameters for updateOrganizationRiskThreat operation in OrganizationRisksApi.
 */
export interface OrganizationRisksApiUpdateOrganizationRiskThreatRequest {
    readonly organizationRiskThreatId: string

    readonly organizationRiskThreatUpdate: OrganizationRiskThreatUpdate
}

/**
 * OrganizationRisksApi - object-oriented interface
 */
export class OrganizationRisksApi extends BaseAPI {
    /**
     * Add threats to an organization risk.
     * @summary Add Organization Risk Threats To Organization Risk
     * @param {OrganizationRisksApiAddOrganizationRiskThreatsToOrganizationRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addOrganizationRiskThreatsToOrganizationRisk(requestParameters: OrganizationRisksApiAddOrganizationRiskThreatsToOrganizationRiskRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).addOrganizationRiskThreatsToOrganizationRisk(requestParameters.organizationRiskId, requestParameters.addOrganizationRiskThreatsToOrganizationRisk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an organization risk.
     * @summary Archive Organization Risk
     * @param {OrganizationRisksApiArchiveOrganizationRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archiveOrganizationRisk(requestParameters: OrganizationRisksApiArchiveOrganizationRiskRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).archiveOrganizationRisk(requestParameters.organizationRiskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete an organization risk category.
     * @summary Archive Organization Risk Category
     * @param {OrganizationRisksApiArchiveOrganizationRiskCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archiveOrganizationRiskCategory(requestParameters: OrganizationRisksApiArchiveOrganizationRiskCategoryRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).archiveOrganizationRiskCategory(requestParameters.organizationRiskCategoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete an organization risk threat.
     * @summary Archive Organization Risk Threat
     * @param {OrganizationRisksApiArchiveOrganizationRiskThreatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archiveOrganizationRiskThreat(requestParameters: OrganizationRisksApiArchiveOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).archiveOrganizationRiskThreat(requestParameters.organizationRiskThreatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new organization risk.
     * @summary Create Organization Risk
     * @param {OrganizationRisksApiCreateOrganizationRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrganizationRisk(requestParameters: OrganizationRisksApiCreateOrganizationRiskRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).createOrganizationRisk(requestParameters.organizationRiskCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an organization risk category for the organization.
     * @summary Create Organization Risk Category
     * @param {OrganizationRisksApiCreateOrganizationRiskCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrganizationRiskCategory(requestParameters: OrganizationRisksApiCreateOrganizationRiskCategoryRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).createOrganizationRiskCategory(requestParameters.organizationRiskCategoryCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an organization risk threat for the organization.
     * @summary Create Organization Risk Threat
     * @param {OrganizationRisksApiCreateOrganizationRiskThreatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrganizationRiskThreat(requestParameters: OrganizationRisksApiCreateOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).createOrganizationRiskThreat(requestParameters.organizationRiskThreatCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an organization risk threat from an organization risk.
     * @summary Delete Organization Risk Threat
     * @param {OrganizationRisksApiDeleteOrganizationRiskThreatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOrganizationRiskThreat(requestParameters: OrganizationRisksApiDeleteOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).deleteOrganizationRiskThreat(requestParameters.organizationRiskId, requestParameters.organizationRiskThreatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a organization risk by its ID.
     * @summary Get Organization Risk
     * @param {OrganizationRisksApiGetOrganizationRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRisk(requestParameters: OrganizationRisksApiGetOrganizationRiskRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRisk(requestParameters.organizationRiskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get organization risk categories of the organization.
     * @summary Get Organization Risk Categories
     * @param {OrganizationRisksApiGetOrganizationRiskCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRiskCategories(requestParameters: OrganizationRisksApiGetOrganizationRiskCategoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRiskCategories(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.includeArchived, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a organization risk category by its ID.
     * @summary Get Organization Risk Category
     * @param {OrganizationRisksApiGetOrganizationRiskCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRiskCategory(requestParameters: OrganizationRisksApiGetOrganizationRiskCategoryRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRiskCategory(requestParameters.organizationRiskCategoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the risk portfolio of the organization: every visible Approved or Pending AI System with its Risk Category roll-ups.
     * @summary Get Organization Risk Portfolio
     * @param {OrganizationRisksApiGetOrganizationRiskPortfolioRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRiskPortfolio(requestParameters: OrganizationRisksApiGetOrganizationRiskPortfolioRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRiskPortfolio(requestParameters.groupBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return one AI System of the portfolio with its Risk Categories, Risks and Threat Vectors.
     * @summary Get Organization Risk Portfolio Project
     * @param {OrganizationRisksApiGetOrganizationRiskPortfolioProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRiskPortfolioProject(requestParameters: OrganizationRisksApiGetOrganizationRiskPortfolioProjectRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRiskPortfolioProject(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return one Risk Category of the portfolio with its Risks and their top AI Systems.
     * @summary Get Organization Risk Portfolio Risk Category
     * @param {OrganizationRisksApiGetOrganizationRiskPortfolioRiskCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRiskPortfolioRiskCategory(requestParameters: OrganizationRisksApiGetOrganizationRiskPortfolioRiskCategoryRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRiskPortfolioRiskCategory(requestParameters.riskCategoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return risk status by category for an organization.
     * @summary Get Organization Risk Status By Category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRiskStatusByCategory(options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRiskStatusByCategory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an organization risk threat.
     * @summary Get Organization Risk Threat
     * @param {OrganizationRisksApiGetOrganizationRiskThreatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRiskThreat(requestParameters: OrganizationRisksApiGetOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRiskThreat(requestParameters.organizationRiskThreatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated organization risk threats for the active organization.
     * @summary Get Organization Risk Threats
     * @param {OrganizationRisksApiGetOrganizationRiskThreatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRiskThreats(requestParameters: OrganizationRisksApiGetOrganizationRiskThreatsRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRiskThreats(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.includeArchived, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all organization risks.
     * @summary Get Organization Risks
     * @param {OrganizationRisksApiGetOrganizationRisksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRisks(requestParameters: OrganizationRisksApiGetOrganizationRisksRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRisks(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationRiskCategoryId, requestParameters.nameOrUniqueCode, requestParameters.includeArchived, requestParameters.exactMatch, requestParameters.organizationRiskThreatIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all organization risks.
     * @summary Get Organization Risks Expanded
     * @param {OrganizationRisksApiGetOrganizationRisksExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRisksExpanded(requestParameters: OrganizationRisksApiGetOrganizationRisksExpandedRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRisksExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.organizationRiskCategoryId, requestParameters.nameOrUniqueCode, requestParameters.includeArchived, requestParameters.exactMatch, requestParameters.organizationRiskThreatIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return risk overview by organization.
     * @summary Get Organization Risks Overview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationRisksOverview(options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationRisksOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return Top risks by category.
     * @summary Get Organization Top Risk Per Category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationTopRiskPerCategory(options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getOrganizationTopRiskPerCategory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query organization risk threats with pagination.
     * @summary Get Risk Threats From Organization Risks
     * @param {OrganizationRisksApiGetRiskThreatsFromOrganizationRisksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRiskThreatsFromOrganizationRisks(requestParameters: OrganizationRisksApiGetRiskThreatsFromOrganizationRisksRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getRiskThreatsFromOrganizationRisks(requestParameters.organizationRiskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return top projects by risk value.
     * @summary Get Top Projects By Risk Value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTopProjectsByRiskValue(options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).getTopProjectsByRiskValue(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an organization risk by its ID.
     * @summary Update Organization Risk
     * @param {OrganizationRisksApiUpdateOrganizationRiskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationRisk(requestParameters: OrganizationRisksApiUpdateOrganizationRiskRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).updateOrganizationRisk(requestParameters.organizationRiskId, requestParameters.organizationRiskUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a organization risk category by its ID.
     * @summary Update Organization Risk Category
     * @param {OrganizationRisksApiUpdateOrganizationRiskCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationRiskCategory(requestParameters: OrganizationRisksApiUpdateOrganizationRiskCategoryRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).updateOrganizationRiskCategory(requestParameters.organizationRiskCategoryId, requestParameters.organizationRiskCategoryUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an organization risk threat by its ID.
     * @summary Update Organization Risk Threat
     * @param {OrganizationRisksApiUpdateOrganizationRiskThreatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationRiskThreat(requestParameters: OrganizationRisksApiUpdateOrganizationRiskThreatRequest, options?: RawAxiosRequestConfig) {
        return OrganizationRisksApiFp(this.configuration).updateOrganizationRiskThreat(requestParameters.organizationRiskThreatId, requestParameters.organizationRiskThreatUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

